import store from "@/store";

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = (num) => {
    return num < 10 ? "0" + num : num;
};
/**
 * @param {String}  时间戳
 * @param {String}  格式
 * @returns {String} 返回：年-月-日
 */
export const getTime = (data, type) => {
    if (data === '' || data === null) {
        return
    } else {
        let _data = data;
        //如果是13位正常，如果是10位则需要转化为毫秒
        if (String(data).length == 13) {
            _data = data;
        } else {
            _data = data * 1000;
        }
        const time = new Date(_data);
        const Y = getHandledValue(time.getFullYear());
        const Mon = getHandledValue(time.getMonth() + 1);
        const Day = getHandledValue(time.getDate());
        const H = getHandledValue(time.getHours());
        const Min = getHandledValue(time.getMinutes());
        const S = getHandledValue(time.getSeconds());
        //自定义选择想要返回的类型
        if (type == "Y") {
            return `${Y}-${Mon}-${Day}`;
        } else if (type == "H") {
            return `${H}:${Min}:${S}`;
        } else {
            return `${Y}-${Mon}-${Day} ${H}:${Min}:${S}`;
        }
    }
};

/**
 * @param {Array} 总数组
 * @param {Array} 需要除去的数组
 * @returns {Array}} 余下的数组
 * @description 取出arr1中不包含arr2的项
 */
export const arrayToHeavy = (arr1, arr2) => {
    return arr1.filter(function (item) {
        return arr2.every(function (item1) {
            return item != item1;
        });
    });
};


export const owenFiexd = (item, num) => {
    let times = Math.pow(10, num);
    let roundNum = Math.round(item * times) / times;
    return roundNum.toFixed(num);
}
/**
 * @param {Object}
 * @param {Number} 保留小数位数
 * @returns {Object}} 修改后的Object
 * @description 修改对象中指定项的保留小数位
 */
export const decimalDigits = (item, num, type) => {
    let month = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december', 'total']
    if (type === 'month') {
        month = ['itemVal']
    }
    month.forEach(_month => {
        item[_month] = item[_month] === '' ? '' : owenFiexd(item[_month], num)
    })
};

export const decimalSteel = (item, num) => {
    const key = [
        'processProductNumber',
        'cokingAndWashingCoal',
        'bituminousCoal',
        'anthraciteCoal',
        'coke',
        'otherSolidFuelsContainingCarbon',
        'naturalGas',
        'outsourcingCokeOvenGas',
        'outsourcingFurnaceGas',
        'outsourcingConverterGas',
        'petrol',
        'diesel',
        'processPowerConsumption',
        'processHeatConsumption',
        'exportTar',
        'exportCrudeBenzene',
        'exportOfCokeOvenGas',
        'exportOfBlastFurnaceGas',
        'exportOfConverterGas',
        'emissionsTotal',
        'emissionsCo2T',
        'other1',
        'other2',
        'other3',
        'other4',
        'other5',
        'liquefiedPetroleumGas',
        'liquefiedNaturalGas'
    ]
    key.forEach(_item => {
        if (item[_item] !== '-' && item[_item] !== '/') {
            item[_item] = item[_item] === '' ? '' : owenFiexd(item[_item], num)
        }
    })
}
